import { render, staticRenderFns } from "./chapter-description.vue?vue&type=template&id=8ef0e708"
import script from "./chapter-description.vue?vue&type=script&lang=js"
export * from "./chapter-description.vue?vue&type=script&lang=js"
import style0 from "./chapter-description.vue?vue&type=style&index=0&id=8ef0e708&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports